import React from 'react'
import StoreGrid from './StoreGrid'
import Navbar from '../Home/Navbar'
import Footer from '../Home/Footer'
import AuthModal from '../Auth/AuthModal.jsx'
import StoreBranches from '../StoreDetails/StoreBranches.jsx'
import { setDocumentTitle, setMetaDescription } from "../../utils/seo";
import { ArrowLeft } from 'lucide-react'
import { useNavigate } from "react-router-dom";

const StoreMain = ({selectedArea, setSelectedArea , isLoggedIn, setIsLoggedIn , setShowAuthModal , showAuthModal}) => {
  const navigate = useNavigate();
  // Set document title for store main page
  React.useEffect(() => {
    setDocumentTitle("UAE In Store Daily Offer Catalogs | Gulf Deals");
    setMetaDescription("Browse the latest store catalogs across the Dubai UAE. Find weekly offers, new promotions, and top deals by store, category, and city with Gulf Deals");
  }, []);


  
  return (
    <div className='min-h-screen flex flex-col'>
      {/* Top nav */}
      <Navbar
        selectedArea={selectedArea}
        setSelectedArea={setSelectedArea}
        isLoggedIn={isLoggedIn}
        setIsLoggedIn={setIsLoggedIn}
        onLoginClick={() => setShowAuthModal(true)}
      />
      <div className='max-w-6xl p-6'>
      <button onClick={() => navigate(`/`)}>
        <ArrowLeft size={20} />
      </button>
      </div>
      <div className='flex-1'>
      <StoreGrid />
      </div>
      <Footer />
      {showAuthModal && (
        <AuthModal
          onClose={() => setShowAuthModal(false)}
          setIsLoggedIn={setIsLoggedIn}
        />
      )}

    </div>
    // <StoreBranches storeId={4} />
  )
}

export default StoreMain
